/**
 * 新商品API
 * 新商品の情報を取得
 */

import { apiGet } from './client';
import type { NewProduct } from '@/lib/types';

// 後方互換性のため、型を再エクスポート
export type { NewProduct } from '@/lib/types';

/**
 * 新商品一覧を取得
 */
export async function getNewProducts(
  accountCode: string,
  baseDate: string,
  authHeaders?: Record<string, string>,
): Promise<NewProduct[]> {
  const params = new URLSearchParams({
    base_date: baseDate,
  });
  return apiGet<NewProduct[]>(`/${accountCode}/new-products?${params}`, authHeaders);
}
